import script from "./PVI.vue?vue&type=script&lang=js"
export * from "./PVI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__